import { useOrganization } from '@/hooks/useOrganization';
import { SubscriptionCenter } from '@/components/billing/SubscriptionCenter';
import { StandardPageHeader } from '@/components/layout/StandardPageHeader';
import { PageContainer } from '@/components/layout/PageContainer';
import { CreditCard } from 'lucide-react';

export default function SubscriptionCenterPage() {
  const { organization, loading } = useOrganization();

  return (
    <div className="space-y-6">
      <StandardPageHeader
        title="Subscription Center"
        subtitle="Manage your organization's subscription and billing"
        icon={CreditCard}
      />
      
      <PageContainer maxWidth="full">
        {!loading && organization ? (
          <SubscriptionCenter organizationId={organization.id} />
        ) : (
          <div className="flex items-center justify-center p-8">
            <div className="text-center space-y-3">
              <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
              <p className="text-sm text-muted-foreground">Loading organization details...</p>
            </div>
          </div>
        )}
      </PageContainer>
    </div>
  );
}